import { render, staticRenderFns } from "./blogItem.vue?vue&type=template&id=35e1a35e&scoped=true&lang=html&"
import script from "./blogItem.vue?vue&type=script&lang=js&"
export * from "./blogItem.vue?vue&type=script&lang=js&"
import style0 from "./blogItem.vue?vue&type=style&index=0&id=35e1a35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1a35e",
  null
  
)

export default component.exports